module.exports = __webpack_public_path__ + "img/17.f31272df.jpg";